import type { UserProfile } from '@seek/apac-candidate-header-footer/types';
import type { AutofillableValue } from '@seek/cmsu-components/src/modules/CForm/types';

import type { HeaderFooterContext } from 'src/gql/generated';

export const getAutofillableValue = (
  caAccountContext?: UserProfile,
  hirerAccountContext?: HeaderFooterContext,
): AutofillableValue => ({
  candidateEmail: caAccountContext?.email || '',
  candidateFirstName: caAccountContext?.firstName || '',
  candidateLastName: caAccountContext?.lastName || '',
  hirerEmail: hirerAccountContext?.identityContext?.email || '',
  hirerName: hirerAccountContext?.user?.name || '',
  hirerBillingId: hirerAccountContext?.advertiser?.billingId || '',
  hirerCompany: hirerAccountContext?.advertiser?.name || '',
});
